import { useMutation } from "@tanstack/react-query";

import { getClient } from "services";

export default function useAnonymousUnsubscribe(encryptedContactKey: string) {
  return useMutation(() =>
    getClient("notificationsService").unsubscribeWithEncryptedTopic(
      encryptedContactKey
    )
  );
}
